import { ActivationPackWithTarget } from '@/types/activation/activation-pack';
import { ActivationPackService } from '@/services/database/ActivationPackService';
import { LookbookBrand } from '@/types/activation/lookbook';

/** Build the lookbook brand inputs from an activation pack. */
export const resolveLookbookBrand = (pack: ActivationPackWithTarget): LookbookBrand => {
  const branding = ActivationPackService.getEffectiveBranding(pack);
  return {
    primary: branding.primaryColor || '#4E9CFF',
    secondary: branding.secondaryColor || '#FF4DB8',
    name: ActivationPackService.getTargetName(pack),
    targetType: ActivationPackService.getTargetType(pack),
    logoUrl: branding.logoUrl || branding.customAvatarUrl || null,
    qrUrl: ActivationPackService.getTargetUrl(pack),
  };
};
